(function () {
  'use strict';

  const HideOneTimePurchase = {

    init() {
      if (!this.isProductPage()) return;
      this.hideOneTimePurchase();
      this.observeDOMChanges();
    },

    isProductPage() {
      return window.location.pathname.startsWith('/products/');
    },

    hideOneTimePurchase() {
      // .plan_card 内の最初の .subscription_group を取得
      const firstGroup = document.querySelector('.plan_card .subscription_group');
      if (!firstGroup) return;

      // 最初の .subscription_group に one_time_purchase が含まれていれば非表示
      if (firstGroup.querySelector('[data-radio-type="one_time_purchase"]')) {
        firstGroup.style.cssText += 'display:none !important;';

        // 2番目以降のサブスクプランのラジオを自動選択
        this.autoSelectSubscription();
      }
    },

    autoSelectSubscription() {
      const subscriptionRadio = document.querySelector(
        '.plan_card [data-radio-type="selling_plan"]'
      );
      if (subscriptionRadio && !subscriptionRadio.checked) {
        subscriptionRadio.click();
      }
    },

    observeDOMChanges() {
      let timer = null;
      const observer = new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(() => this.hideOneTimePurchase(), 50);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => HideOneTimePurchase.init());
  } else {
    HideOneTimePurchase.init();
  }
})();
